import * as yup from "yup";

export const PaydayAdvanceSetupValidationSchema = yup.object().shape({
  employeeId: yup.string().required("Employee is required"),
  dateNo: yup.string().required("Date is required"),
  amount: yup.number().required("Amount is required"),
  paidBy: yup.number().required("Paid By is required"),
  chequeNo: yup
    .string()
    // .required("Cheque No is required")
    .max(25, "Maximum length 25 characters"),
  printOnCheque: yup.string().required("Print on Cheque is required"),
  notes: yup.string().max(100, "Maximum length 100 characters"),
});
